import { InspectionStatuses, InspectionTypes, OffsiteFacility } from './../shared/models/Inspection';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "../../shared/services/alert.service";
import { InspectionService } from "../shared/services/inspection.service";
import { Inspection, InspectionFee, InspectionTypes as ITPS} from "../shared/models/Inspection";
import * as Constants from "../../models/Constants";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { environment } from "../../../environments/environment";
import { ErisFormComponent } from "eris-forms";
import { ErrorHandlerService } from '../../services/error-handler.service';
import { InspectionDraftService, InspectionDraftModel } from "../shared/services/inspection-draft.service";
import { ErisLoginService } from "../../services/sso/eris-login.service";

@Component({
  selector: "app-create-abroad-cgmp-inspection",
  templateUrl: "./create-abroad-cgmp-inspection.component.html",
  styleUrls: ["./create-abroad-cgmp-inspection.component.css"],
})
export class CreateAbroadCgmpInspectionComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(ErisFormComponent) erisFormComponent!: ErisFormComponent;
  public currentInspectionType: string;
  public title: string;
  public approvalMethod: string = Constants.CATEGORY_B;
  public isEditMode = false;
  public inspection: Inspection;
  public form = new FormGroup({});
  public options: FormlyFormOptions = {};
  public inspectionListLink = "";
  public inspectionFees :InspectionFee[] = [];
  public sraDetail : string = "";
  public categoryId : number = 0;
  public agencyId : number = 0;
  public applicantTypeId : number = 0;
  public isFIREditing : boolean = false;
  public draft: InspectionDraftModel;
  public draftId: number;
  private isSavingDraft: boolean = false;

  constructor(private inspectionService: InspectionService, private spinner: NgxSpinnerService, private alertService: AlertService,
    private router: Router, private activatedRoute: ActivatedRoute, private cdr: ChangeDetectorRef, private errorHandlerService: ErrorHandlerService,
    private inspectionDraftService: InspectionDraftService, private erisLoginService: ErisLoginService) {
    this.currentInspectionType = this.activatedRoute.snapshot.params[
      "inspectionTypeCode"
    ];

    this.activatedRoute.params.subscribe((params) => {
      const inspectionTypeCode = params["inspectionTypeCode"];
      const legacyData : boolean = (/true/i).test( params['legacy']);
      this.title = legacyData ? 'Legacy Data Editing' : `${ITPS.codeToName(inspectionTypeCode)} Inspection`  ;
      this.currentInspectionType = inspectionTypeCode;
      this.inspectionListLink = this.currentInspectionType == 'NACI' ? "/inspections/abroadCGMP/list/ABROADCGMP" :
        "/inspections/abroadCGMP/list/ABROADCGMPWAIVER";
    });
  }

  private mergeDraftModels(...sources: any[]): any {
    const target: any = {};
    for (const src of sources) {
      if (!src || typeof src !== 'object') continue;
      for (const key of Object.keys(src)) {
        const val = src[key];
        if (val && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date)) {
          target[key] = this.mergeDraftModels(target[key] || {}, val);
        } else if (val !== undefined && val !== null && val !== '') {
          target[key] = val;
        } else if (!(key in target)) {
          target[key] = val;
        }
      }
    }
    return target;
  }

  private saveDraftListener = (e: any) => {
    const m = e?.detail?.model || {};
    if (typeof e?.detail?.activeStep === 'number') {
      m.activeStep = e.detail.activeStep;
    }
    this.saveDraft(m);
  };

  ngOnInit(): void {
    window.addEventListener('eris-save-draft', this.saveDraftListener);
    this.inspectionService.getInspectionFees().subscribe(resp => {
      this.inspectionFees = resp;
      let sraInspFee = this.inspectionFees.find(f => f.isSra == true);
      if(sraInspFee){
        this.sraDetail = sraInspFee.description;
      }
    });

    if (this.fields?.[0]) {
      (this.fields[0] as any).templateOptions = {
        ...((this.fields[0] as any).templateOptions || {}),
        saveDraft: (m?: any) => this.saveDraft(m)
      };
    }
    if (this.waiverFields?.[0]) {
      (this.waiverFields[0] as any).templateOptions = {
        ...((this.waiverFields[0] as any).templateOptions || {}),
        saveDraft: (m?: any) => this.saveDraft(m)
      };
    }
    this.options.formState = {
      ...this.options.formState,
      saveDraft: (m?: any) => this.saveDraft(m)
    };
  }

  ngOnDestroy(): void {
    window.removeEventListener('eris-save-draft', this.saveDraftListener);
  }

  ngAfterViewInit() : void{
    const id = this.activatedRoute.snapshot.params['id'];
    const draftId = this.activatedRoute.snapshot.queryParams['draftId'] || this.activatedRoute.snapshot.params['draftId'];
    if(id){
      this.isEditMode = true;
      this.fetchInspectionData(id);
    } else if (draftId) {
      this.draftId = +draftId;
      this.fetchDraftData(this.draftId);
    }
  }

  fetchDraftData(draftId: number) {
    this.spinner.show();
    this.inspectionDraftService.getDraft(draftId).subscribe(
      draft => {
        this.spinner.hide();
        if (draft && draft.inspectionJsonData) {
          this.draft = draft;
          const sId = draft.id || (draft as any)?.ID;
          if (sId) {
            this.draft.id = sId;
            this.draftId = sId;
          }
          try {
            const parsed = JSON.parse(draft.inspectionJsonData);
            if (parsed.productionInformation) {
              const prodDetails = parsed.productionInformation.productDetailData?.productDetails || parsed.productionInformation.productDetails;
              if (prodDetails) {
                parsed.productionInformation.productDetails = prodDetails;
                parsed.productionInformation.productDetailData = { productDetails: prodDetails };
              }
            }
            if (typeof parsed.activeStep === 'number') {
              if (this.options?.formState) {
                (this.options.formState as any).activeStep = parsed.activeStep;
              }
            }
            if (this.erisFormComponent) {
              this.erisFormComponent.model = parsed;
            }
            this.cdr.detectChanges();
          } catch (e) {
            console.error('Error parsing draft data', e);
          }
        }
      },
      err => {
        this.spinner.hide();
        this.alertService.error('Unable to fetch drafted inspection');
      }
    );
  }

  saveDraft(model?: any) {
    if (this.isSavingDraft) {
      return;
    }
    this.isSavingDraft = true;
    this.spinner.show();
    const formVal = this.erisFormComponent?.form?.value || {};
    const rootModel = this.erisFormComponent?.model || {};
    const passedModel = model || {};
    const currentModel = this.mergeDraftModels(rootModel, passedModel, formVal);

    const prodDetails =
      passedModel.productionInformation?.productDetailData?.productDetails ||
      passedModel.productionInformation?.productDetails ||
      rootModel.productionInformation?.productDetailData?.productDetails ||
      rootModel.productionInformation?.productDetails ||
      formVal.productionInformation?.productDetailData?.productDetails ||
      formVal.productionInformation?.productDetails ||
      currentModel.productionInformation?.productDetailData?.productDetails ||
      currentModel.productionInformation?.productDetails;

    if (prodDetails && Array.isArray(prodDetails) && prodDetails.length > 0) {
      if (!currentModel.productionInformation) {
        currentModel.productionInformation = {};
      }
      currentModel.productionInformation.productDetails = prodDetails;
      currentModel.productionInformation.productDetailData = { productDetails: prodDetails };
    }

    const step = (model && typeof model.activeStep === 'number')
      ? model.activeStep
      : (typeof rootModel.activeStep === 'number'
          ? rootModel.activeStep
          : (typeof (this.options?.formState as any)?.activeStep === 'number'
              ? (this.options.formState as any).activeStep
              : undefined));
    if (typeof step === 'number') {
      currentModel.activeStep = step;
      if (this.options?.formState) {
        (this.options.formState as any).activeStep = step;
      }
    }

    if (this.erisFormComponent) {
      this.erisFormComponent.model = currentModel;
    }

    const typeCode = this.currentInspectionType || 'NACI';
    const userId = this.erisLoginService.getUserId();

    if (!this.draft) {
      this.draft = new InspectionDraftModel(JSON.stringify(currentModel), userId, 0);
      this.draft.inspectionTypeCode = typeCode;
      if (this.draftId) {
        this.draft.id = this.draftId;
      }
    } else {
      if (!this.draft.id && this.draftId) {
        this.draft.id = this.draftId;
      }
      this.draft.inspectionJsonData = JSON.stringify(currentModel);
      this.draft.inspectionTypeCode = typeCode;
      this.draft.savedBy = userId;
      this.draft.createdBy = userId;
    }

    this.inspectionDraftService.saveDraft(this.draft).subscribe(
      res => {
        this.isSavingDraft = false;
        this.spinner.hide();
        if (res) {
          const sId = res.id || (res as any)?.ID;
          if (sId) {
            res.id = sId;
            this.draftId = sId;
          }
          this.draft = res;
          this.alertService.success('Inspection application saved as a draft successfully');
        } else {
          this.alertService.error('Unable to save inspection application as a draft!');
        }
      },
      error => {
        this.isSavingDraft = false;
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(error));
      }
    );
  }

  fetchInspectionData(inspectionId){
    this.spinner.show();
    this.inspectionService.getInspection(inspectionId).subscribe(data => {
      this.inspection = data;
      this.isFIREditing = [InspectionStatuses.FIR_REQUESTED_BEFORE_INSPECTION, 
        InspectionStatuses.FIR_REQUESTED_AFTER_INSPECTION].includes(data.status.inspectionStatusCode);

      const abroadLink = data.inspectionAbroadFacility?.[0];
      const abroadFacility = abroadLink?.abroadFacility;
      if (!abroadLink || !abroadFacility?.manufacturer) {
        this.spinner.hide();
        this.alertService.error(
          "Abroad facility link is missing for this inspection. Contact support or repair the legacy link before editing."
        );
        return;
      }

      var localAgent = {
        approvedLocalAgent : null,
        localAgentName: abroadFacility.localAgentName,
        phone: abroadFacility.localAgentPhone,
        email: abroadFacility.localAgentEmail,
      };

      if(abroadFacility.approvedAgent){
        localAgent.approvedLocalAgent = { id : abroadFacility.approvedAgent.id, 
                                          name: abroadFacility.approvedAgent.name,
                                          email: abroadFacility.approvedAgent.email,
                                          phone: abroadFacility.approvedAgent.phone};
      } else {
        localAgent.approvedLocalAgent = { id : 0, name : 'Other'};
      }

      var manufacturer = {
        manufacturerName: abroadFacility.manufacturer.name,
        country: abroadFacility.manufacturer.country,
        site: abroadFacility.manufacturer.siteAddress,
        email: abroadFacility.manufacturer.email,
        website: abroadFacility.manufacturer.website,
        previousGmpNumber: data.previousGMPCertificateNumber,
        previousGMPCertificateCountry: data.previousGMPIssuingCountry,

        qualityAssuranceName: abroadFacility.qualityAssuranceName,
        qualityAssurancePhone:abroadFacility.qualityAssurancePhone,
        qualityAssuranceEmail:abroadFacility.qualityAssuranceEmail,

        qualityControlName: abroadFacility.qualityControlName,
        qualityControlPhone:abroadFacility.qualityControlPhone,
        qualityControlEmail:abroadFacility.qualityControlEmail,

        productManagerName: abroadFacility.productManagerName,
        productManagerPhone:abroadFacility.productManagerPhone,
        productManagerEmail:abroadFacility.productManagerEmail,

        internationalMarketingName: abroadFacility.internationalMarketingName,
        internationalMarketingPhone:abroadFacility.internationalMarketingPhone,
        internationalMarketingEmail:abroadFacility.internationalMarketingEmail,

        regularityAffairName: abroadFacility.regularityAffairName,
        regularityAffairPhone:abroadFacility.regularityAffairPhone,
        regularityAffairEmail:abroadFacility.regularityAffairEmail,

        ownerName: abroadFacility.ownerName,
        ownerPhone:abroadFacility.ownerPhone,
        ownerEmail:abroadFacility.ownerEmail,
      };

      this.approvalMethod = data.productionInfo.approvalMethod?.name;
      let productionInformation = {};
      if(this.inspection.type.inspectionTypeCode == ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER){
        if (this.approvalMethod == Constants.CATEGORY_A) {
          productionInformation = {
            category: data.productionInfo.approvalMethod,
            agency: data.productionInfo.agency,
            brandName: data.productionInfo.productBrandName,
            dosageForms: data.productionInfo.prodInfoDosageForms?.map(p => p.dosageForm),
            genericName: data.productionInfo.productGenericName
          };
        } else {
          productionInformation = {
            category: data.productionInfo.approvalMethod,
            country: data.productionInfo.country,
            productDetailData: {
              productDetails: data.productionInfo.productDetails?.filter(p => p.productionLine?.isActive == true)
            }
          };
        }
      } else {
        productionInformation = {    
          productDetailData: {
            productDetails: data.productionInfo.productDetails?.filter(p => p.productionLine?.isActive == true)
          }
        };
      }

      var tempModel = {
        applicantInformation: { 
          applicantType : {
            id: abroadLink.applicantTypeID, name: abroadLink.applicantType?.name
          },
          applicantName: abroadLink.applicantName,
          applicantPhone: abroadLink.applicantPhone,
          applicantEmail: abroadLink.applicantEmail,
          applicantStreet: abroadLink.applicantStreet,
          applicantCountry : null
        },
        localAgentInformation: localAgent,
        manufacturer: manufacturer,
        productionInformation: productionInformation,
        paymentInformation: {},
        fileAttachment: {documents: data.documents}
      };
      
      if(abroadLink.applicantCountryID){
        tempModel.applicantInformation.applicantCountry = {
          id: abroadLink.applicantCountryID, name: abroadLink.applicantCountry?.name
        };
      }

      if(this.inspection.appliedFees && this.inspection.appliedFees.length > 0){
        let isSra = this.inspection.appliedFees.findIndex(f => f.isSra == true) != -1;     
        tempModel.paymentInformation['WHRF'] = this.inspection.appliedFees.findIndex(f => f.code == 'WHRF') > -1;
        tempModel.paymentInformation['PFPQ'] = this.inspection.appliedFees.findIndex(f => f.code == 'PFPQ') > -1;
        tempModel.paymentInformation['QCDL'] = this.inspection.appliedFees.findIndex(f => f.code == 'QCDL') > -1;
        if(!isSra){
          let paymentAddrFee = this.inspection.appliedFees.find(f => f.isSra == false && f.hasMultipleFacility == false && f.code != 'MTTP');
          if(paymentAddrFee){
            tempModel.paymentInformation['inspectionFee'] = { ...paymentAddrFee, name: paymentAddrFee.type };
          }
          var siteAddress = this.inspection.appliedFees.find(a => a.siteAddress != null)?.siteAddress;
          tempModel.paymentInformation['siteAddress'] = siteAddress;
        }
        //TODO: find a better way
        // for uknown reason the segmented control view is not updated to the value it is set to, so i used a hacky way to set the selectedIndex
        // @ts-ignore
        this.erisFormComponent.fields[0].fieldGroup[4].fieldGroup[0].fieldGroup[0]._componentRefs[0].instance.selectedIndex = isSra ? 0 : 1;
      }

      this.categoryId = data.productionInfo.approvalMethod?.id;
      this.agencyId = data.productionInfo.agency?.id;
      this.applicantTypeId = abroadLink.applicantTypeID;

      this.erisFormComponent.model = tempModel;
      this.cdr.detectChanges();
      this.spinner.hide()
    }, err => {
      this.spinner.hide();
      if(this.isEditMode){
        this.alertService.error("The Inspection Couldn't be Retrieved for Editing!");
      } else {
        this.alertService.error("The Previous Inspection Couldn't be Retrieved!");
      }
    })
  }

  submitForm(event) {
    this.spinner.show();

    var link = "";
    var path = "ABROADCGMP";
    if (this.currentInspectionType == "NACI") {
      link = "New";
    } else if (this.currentInspectionType == "NACIW") {
      link = "Waiver/New";
      path = "ABROADCGMPWAIVER";
    }

    if(this.isFIREditing) {
      this.inspectionService.submitFurtherInformation(this.inspection.id, event.fileAttachment).subscribe(res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success("Your Application was submitted successfully");
          this.router.navigate(["inspections/abroadCGMP/list/"+path]);
        } else {
          this.alertService.error("Unable to submit your Application, please try again!");
        }
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(error));
      });    
    } else {
      // we only need the appliedFees array, we can rebuild the other fields from it
      event.productionInformation["productDetails"] = event.productionInformation.productDetailData?.productDetails;
      let appliedFees = this.inspectionService.getAppliedFees(event, this.currentInspectionType, this.inspectionFees);
      const address = event.paymentInformation.siteAddress;
      event.paymentInformation = {
        ...event.paymentInformation,
        appliedFees: appliedFees 
      };
      for (var element of event.paymentInformation.appliedFees) {
        element.siteAddress = address;
      }

      if(!this.isEditMode){
        this.inspectionService.postAbroadApplicationForm(event, link).subscribe(res => {
          this.spinner.hide();
          if (res) {
            if (this.draft && this.draft.id) {
              this.inspectionDraftService.deleteDraft(this.draft.id, this.erisLoginService.getUserId()).subscribe();
            }
            this.alertService.success("Your Application was submitted successfully");
            this.router.navigate(["inspections/abroadCGMP/list/"+path]);
          } else {
            this.alertService.error("Unable to submit your Application, please try again!");
          }
        }, error => {
          console.log(error);
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(error));
        });
      } else {
        event.inspectionId = this.inspection.id;
        this.inspectionService.editAbroadApplicationForm(event, link).subscribe(res => {
          this.spinner.hide();
          if (res) {
            if (this.draft && this.draft.id) {
              this.inspectionDraftService.deleteDraft(this.draft.id, this.erisLoginService.getUserId()).subscribe();
            }
            this.alertService.success("Your Application was edited successfully");
            this.router.navigate(["inspections/abroadCGMP/list/"+path]);
          } else {
            this.alertService.error("Unable to edit your Application, please try again!");
          }
        }, error => {
          console.log(error);
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(error));
        });
      }
    }
  }

  waiverFields: any = [
    {
      type: "draft-steps",
      templateOptions: {},
      fieldGroup: [
        {
          key: "applicantInformation",

          templateOptions: { title: "Applicant Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  key: "applicantType",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Applicant Type",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => {
                      this.applicantTypeId = res.id;
                      return ({
                        name: res.name,
                        id: res.id,
                      })
                    },
                    list: {
                      method: "get",
                      url: (term) =>
                        `${environment.baseUrl}/ApplicantType/AbroadCGMP`,
                      responseFn: (res) => res,
                    },
                  },
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>License Holder</strong></h2></div>",
                      hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                          var applicantType = field.form.get("applicantType")?.value;
                          if (applicantType != null && applicantType.name == 'License Holder') {
                            return false;
                          }
                          return true;
                      },
                    },
                    
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Representative</strong></h2></div>",
                      hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                        var applicantType = field.form.get("applicantType")?.value;
                        if (applicantType != null && applicantType.name == 'Representative') {
                          return false;
                        }
                        return true;
                      },
                    },
                  ],
                },
                {
                  key: "applicantName",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    required: true,
                    label: "Name",
                    type: "text",
                  },
                  validators: {
                    validation: ["normal-text"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "applicantCountry",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Country",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => ({
                      name: res.name,
                      id: res.id,
                    }),
                    list: {
                      method: "get",
                      url: (term) => `${environment.baseUrl}/Country`,
                      responseFn: (res) => res,
                    },
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "applicantStreet",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    required: true,
                    label: "Street",
                    type: "text",
                  },
                  validators: {
                    validation: ["normal-text"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "applicantPhone",
                  type: "international-phone",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Phone",
                    required: false,
                    dependsOnField: "applicantInformation.applicantType",
                    editing: false,
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                  expressionProperties: {
                    "templateOptions.required": (model, formState, field: FormlyFieldConfig) => {
                      var applicantType = field.form.get("applicantType")?.value;
                      if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                        return true;
                      }
                      return false;
                    },
                    "templateOptions.editing": () => {
                      return this.isEditMode;
                    },
                  }
                },
                {
                  key: "applicantEmail",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Email Address",
                    type: "email",
                    required: true,
                  },
                  validators: {
                    validation: ["email"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "localAgentInformation",
          fieldGroupClassName: "row",
          templateOptions: { title: "Local Agent Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  key: "approvedLocalAgent",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: 'Local Agent',
                    multiple: false,
                    prefetch: false,
                    searchable: true,
                    minLengthTerm: 3,
                    required: true,
                    responseFn: (res) => ({name: res?.name, id: res?.id, phone: res?.phone, email: res?.email}),
                    list: {
                      method: 'post',
                      url: (term) => `${environment.baseUrl}/LocalAgent/Search`,
                      data: (term) => ({query: term, pageNumber: 0, pageSize: 50}),
                      responseFn: res => {
                        if(res?.data) {
                          res.data.push({name: 'Other', id : 0});
                          return res.data;
                        } else {
                          return [{name: 'Other', id : 0}]
                        }
                      }
                    },
                  },
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br>",
                    },
                  ],
                },
                {
                  key: "approvedAgentPhone",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Phone",
                    type: "text",
                    disabled: true,
                    placeholder: '',
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                      return false;
                    }
                    return true;
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                      return model.approvedLocalAgent?.phone;
                    },
                  },
                },
                {
                  key: "approvedAgentEmail",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Email",
                    type: "text",
                    disabled: true,
                    placeholder: '',
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                      return false;
                    }
                    return true;
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                      return model.approvedLocalAgent?.email;
                    },
                  },
                },
                {
                  key: "localAgentName",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Name of Local Agent",
                    type: "text",
                    required: true,
                  },
                  validators: {
                    validation: ["normal-text"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "phone",
                  type: "international-phone",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Phone",
                    required: true,
                    editing: false,
                  },
                  expressionProperties: {
                    "templateOptions.editing": () => {
                      return this.isEditMode;
                    },
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "email",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Email Address",
                    required: true,
                    type: "email",
                  },
                  validators: {
                    validation: ["email"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                      return false;
                    }
                    return true;
                  },
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "manufacturer",
          templateOptions: { title: "Manufacturer" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "manufacturerName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        type: "text",
                        label: "Manufacturer Name",
                        required: true,
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "country",
                      type: "lookup",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Country",
                        required: true,
                        multiple: false,
                        prefetch: true,
                        searchable: false,
                        minLengthTerm: 0,
                        responseFn: (res) => ({
                          name: res.name,
                          id: res.id,
                        }),
                        list: {
                          method: "get",
                          url: (term) => `${environment.baseUrl}/Country`,
                          responseFn: (res) => res,
                        },
                      },
                    },
                    {
                      key: "site",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        type: "text",
                        label: "Site Address",
                        required: true,
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "email",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email Address",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                    {
                      key: "website",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Website",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "previousGmpNumber",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Other Country GMP Certificate",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "previousGMPCertificateCountry",
                      type: "lookup",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Issuing Country of Certificate",
                        required: true,
                        multiple: false,
                        prefetch: true,
                        searchable: false,
                        minLengthTerm: 0,
                        responseFn: (res) => ({
                          name: res.name,
                          id: res.id,
                        }),
                        list: {
                          method: "get",
                          url: (term) => `${environment.baseUrl}/Country`,
                          responseFn: (res) => res,
                        },
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Key Persons of the Manufacturer</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Quality Assurance</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "qualityAssuranceName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "qualityAssurancePhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "qualityAssuranceEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Quality Control</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "qualityControlName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "qualityControlPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "qualityControlEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Product Manager</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "productManagerName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "productManagerPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "productManagerEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>International Marketing</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "internationalMarketingName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "internationalMarketingPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "internationalMarketingEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Regularity Affair</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "regularityAffairName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "regularityAffairPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "regularityAffairEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Owner</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "ownerName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: false,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "ownerPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: false,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "ownerEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: false,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "productionInformation",
          templateOptions: { title: "Production Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  key: "category",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "SRA Category",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => {
                      this.categoryId = res.id; 
                      return ({
                        name: res.name,
                        id: res.id,
                      });
                    },
                    list: {
                      method: "get",
                      url: (term) => `${environment.baseUrl}/ApprovalMethod`,
                      responseFn: (res) => res,
                    },
                  },
                },
                {
                  key: "agency",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Agency",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => { 
                      this.agencyId = res.id; 
                      return ({
                      name: res.name,
                      id: res.id,
                    })
                  } ,
                    list: {
                      method: "get",
                      url: (term) => `${environment.baseUrl}/Agency`,
                      responseFn: (res) => res,
                    },
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    var id = field.form.get("category").value;
                    if (id != null) {
                      if (id["id"] == 1) {
                        return false;
                      }
                      return true;
                    }
                    return true;
                  },
                },
                {
                  key: "brandName",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Brand Name",
                    type: "text",
                    required: true
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    var id = field.form.get("category").value;
                    if (id != null) {
                      if (id["id"] == 1) {
                        return false;
                      }
                      return true;
                    }
                    return true;
                  },
                },
                {
                  key: "genericName",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Generic Name",
                    type: "text",
                    required: true,
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    var id = field.form.get("category").value;
                    if (id != null) {
                      if (id["id"] == 1) {
                        return false;
                      }
                      return true;
                    }
                    return true;
                  },
                },
                {
                  key: "dosageForms",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: 'Dosage Form',
                    multiple: true,
                    prefetch: false,
                    searchable: true,
                    minLengthTerm: 3,
                    required: true,
                    responseFn: (res) => {
                      return res;
                    },
                    list: {
                      method: 'post',
                      url: (term) => `${environment.baseUrl}/DosageForm/Search`,
                      data: (term) => ({query: term, pageNumber: 0, pageSize: 50}),
                      responseFn: res => res?.data
                    },
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    var id = field.form.get("category").value;
                    if (id != null) {
                      if (id["id"] == 1) {
                        return false;
                      }
                      return true;
                    }
                    return true;
                  },
                },
                {
                  key: "country",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Country",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    dependsOnField: "category",
                    responseFn: (res) => ({
                      name: res.name,
                      id: res.id,
                    }),
                    list: {
                      method: "get",
                      url: (term) => `${environment.baseUrl}/Country/bycategory/${this.categoryId}`,
                      responseFn: (res) => res,
                    },
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    var id = field.form.get("category").value;
                    if (id != null) {
                      if (id["id"] == 2 || id["id"] == 3) {
                        return false;
                      }
                      return true;
                    }
                    return true;
                  },
                },
                {
                  key: "productDetailData",
                  type: "gmp-product-detail",
                  className: "col-md-12",
                  templateOptions: {
                    isDisabled: false,
                    dependsOnField: "productionInformation.category",
                    editing: false
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    let cat = field.form.get("category").value;
                    if (cat != null) {
                      if (cat["id"] == 2 || cat["id"] == 3) {
                        return false;
                      }
                      return true;
                    }
                    return true;
                  },
                  expressionProperties: {
                    "templateOptions.editing": () => {
                      return this.isEditMode;
                    },
                  }
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "paymentInformation",
          templateOptions: { title: "Payment Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
               
                {
                  className: "col-md-7",
                  type: 'textarea',
                  templateOptions: {
                    label: "Detail",
                    placeholder: "",
                    rows: 3,
                    disabled: true
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': () => {
                      return this.sraDetail;
                    },
                  },
                },
                {
                  type: "input",
                  className: "col-md-7",
                  templateOptions: {
                    label: 'Total Fee',
                    placeholder: '0',
                    dependsOnField: "productionInformation.productDetailData",
                    disabled: true
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                      let appliedFees = [];
                      let totalFee = 0;
                      // for waiver -> Desk Audit (always)
                      if(this.inspectionFees.length > 0) {
                        appliedFees.push(this.inspectionFees.find(f => f.isSra == true));   
                        totalFee += appliedFees[0].amount;   
                      }                  

                      let prodDetails = field.form.parent?.value?.productionInformation?.productDetailData?.productDetails;

                      // multiple offsite facility payment
                      if(prodDetails && prodDetails.length > 0) {
                        const { uniqueOffsiteFacilitiesByNameAndAddressCount } = this.inspectionService.getOffsiteFacilitiesInfo(prodDetails)  

                        if(uniqueOffsiteFacilitiesByNameAndAddressCount > 0) {
                          appliedFees.push(this.inspectionFees.find(f => f.code == "MOF"));
                          totalFee += (uniqueOffsiteFacilitiesByNameAndAddressCount * this.inspectionFees.find(f => f.code == "MOF").amount);
                        }                       
                      }

                      return totalFee + " (in USD)"; 
                    },
                  },
                },   
                {
                  fieldGroupClassName: "col-md-7",
                  fieldGroup: [
                    {
                      template: "",
                     
                      expressionProperties: {
                        'template': () => {
                          let multipleOffsiteFacilityFee = this.inspectionFees.find(f => f.code == 'MOF');
                          if(multipleOffsiteFacilityFee){
                            let template = `<span><span class='text-danger'>*</span>when offsite facilities are added, 
                              each offsite facility added costs ${multipleOffsiteFacilityFee.amount} (in USD) </span>`
                            return template;
                          }
                        },
                      },
                    },
                  ],
                },         
              ]
            }
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "fileAttachment",
          templateOptions: {
            title: "File Attachment",
            icon: "fa fa-info-circle",
          },
          fieldGroup: [
            {
              key: "documents",
              type: "upload-list",

              templateOptions: {
                label: "Applicant Name",
                required: true,
                items: [],
                dependsOnField: "productionInformation",
                dataSourceFn: (submoduleCode) => {
                  return {
                    url: `/DocumentRef/GMP/${submoduleCode}`,
                  };
                },
                extraData: {
                  urlParameter: "",
                  originalFileName: "-",
                  editing: false,
                  categoryTypeID: "",
                  AgencyTypeID: "",
                  ApplicantTypeID: "",
                },
                responseFn: (res) => res,
              },
              expressionProperties: {
                "templateOptions.extraData.urlParameter": (
                  model,
                  formState,
                  field
                ) => {
                  return this.currentInspectionType;
                },
                "templateOptions.extraData.editing": () => {
                  return this.isEditMode;
                },
                "templateOptions.extraData.categoryTypeID": () => {
                  return this.categoryId;
                },
                "templateOptions.extraData.AgencyTypeID": () => {
                  return this.agencyId;
                },
                "templateOptions.extraData.ApplicantTypeID": () => {
                  return this.applicantTypeId;
                },
              },
            },
          ],
        },
      ],
    },
  ];

  fields: any = [
    {
      type: "draft-steps",
      templateOptions: {},
      fieldGroup: [
        {
          key: "applicantInformation",

          templateOptions: { title: "Applicant Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  key: "applicantType",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Applicant Type",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => {
                      this.applicantTypeId = res.id;
                      return ({
                        name: res.name,
                        id: res.id,
                      })
                    },
                    list: {
                      method: "get",
                      url: (term) =>
                        `${environment.baseUrl}/ApplicantType/AbroadCGMP`,
                      responseFn: (res) => res,
                    },
                  },
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>License Holder</strong></h2></div>",
                      hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                          var applicantType = field.form.get("applicantType")?.value;
                          if (applicantType != null && applicantType.name == 'License Holder') {
                            return false;
                          }
                          return true;
                      },
                    },
                    
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Representative</strong></h2></div>",
                      hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                        var applicantType = field.form.get("applicantType")?.value;
                        if (applicantType != null && applicantType.name == 'Representative') {
                          return false;
                        }
                        return true;
                      },
                    },
                  ],
                },
                {
                  key: "applicantName",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    required: true,
                    label: "Name",
                    type: "text",
                  },
                  validators: {
                    validation: ["normal-text"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "applicantCountry",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Country",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => ({
                      name: res.name,
                      id: res.id,
                    }),
                    list: {
                      method: "get",
                      url: (term) => `${environment.baseUrl}/Country`,
                      responseFn: (res) => res,
                    },
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "applicantStreet",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    required: true,
                    label: "Street",
                    type: "text",
                  },
                  validators: {
                    validation: ["normal-text"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "applicantPhone",
                  type: "international-phone",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Phone",
                    required: false,
                    dependsOnField: "applicantInformation.applicantType",
                    editing: false,
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                  expressionProperties: {
                    "templateOptions.required": (model, formState, field: FormlyFieldConfig) => {
                      var applicantType = field.form.get("applicantType")?.value;
                      if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                        return true;
                      }
                      return false;
                    },
                    "templateOptions.editing": () => {
                      return this.isEditMode;
                    },
                  }
                },
                {
                  key: "applicantEmail",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Email Address",
                    type: "email",
                    required: true,
                  },
                  validators: {
                    validation: ["email"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var applicantType = field.form.get("applicantType")?.value;
                    if (applicantType != null && (applicantType.name == 'Representative' || applicantType.name == 'License Holder')) {
                      return false;
                    }
                    return true;
                  },
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "localAgentInformation",
          fieldGroupClassName: "row",
          templateOptions: { title: "Local Agent Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  key: "approvedLocalAgent",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: 'Local Agent',
                    multiple: false,
                    prefetch: false,
                    searchable: true,
                    minLengthTerm: 3,
                    required: true,
                    responseFn: (res) => ({name: res?.name, id: res?.id, phone: res?.phone, email: res?.email}),
                    list: {
                      method: 'post',
                      url: (term) => `${environment.baseUrl}/LocalAgent/Search`,
                      data: (term) => ({query: term, pageNumber: 0, pageSize: 50}),
                      responseFn: res => {
                        if(res?.data) {
                          res.data.push({name: 'Other', id : 0});
                          return res.data;
                        } else {
                          return [{name: 'Other', id : 0}]
                        }
                      }
                    },
                  },
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br>",
                    },
                  ],
                },
                {
                  key: "approvedAgentPhone",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Phone",
                    type: "text",
                    disabled: true,
                    placeholder: '',
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                      return false;
                    }
                    return true;
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                      return model.approvedLocalAgent?.phone;
                    },
                  },
                },
                {
                  key: "approvedAgentEmail",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Email",
                    type: "text",
                    disabled: true,
                    placeholder: '',
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                      return false;
                    }
                    return true;
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                      return model.approvedLocalAgent?.email;
                    },
                  },
                },
                {
                  key: "localAgentName",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Name of Local Agent",
                    type: "text",
                    required: true,
                  },
                  validators: {
                    validation: ["normal-text"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "phone",
                  type: "international-phone",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Phone",
                    required: true,
                    editing: false,
                  },
                  expressionProperties: {
                    "templateOptions.editing": () => {
                      return this.isEditMode;
                    },
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                      return false;
                    }
                    return true;
                  },
                },
                {
                  key: "email",
                  type: "input",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Email Address",
                    required: true,
                    type: "email",
                  },
                  validators: {
                    validation: ["email"],
                  },
                  hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                    var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                    if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                      return false;
                    }
                    return true;
                  },
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "manufacturer",
          templateOptions: { title: "Manufacturer" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "manufacturerName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        type: "text",
                        label: "Manufacturer Name",
                        required: true,
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "country",
                      type: "lookup",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Country",
                        required: true,
                        multiple: false,
                        prefetch: true,
                        searchable: false,
                        minLengthTerm: 0,
                        responseFn: (res) => ({
                          name: res.name,
                          id: res.id,
                        }),
                        list: {
                          method: "get",
                          url: (term) => `${environment.baseUrl}/Country`,
                          responseFn: (res) => res,
                        },
                      },
                    },
                    {
                      key: "site",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        type: "text",
                        label: "Site Address",
                        required: true,
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "email",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email Address",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "website",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Website",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                  ],
                },

                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Key Persons of the Manufacturer</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Quality Assurance</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "qualityAssuranceName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "qualityAssurancePhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "qualityAssuranceEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Quality Control</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "qualityControlName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "qualityControlPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "qualityControlEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Product Manager</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "productManagerName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "productManagerPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "productManagerEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>International Marketing</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "internationalMarketingName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "internationalMarketingPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "internationalMarketingEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Regularity Affair</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "regularityAffairName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: true,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "regularityAffairPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: true,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "regularityAffairEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: true,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Owner</strong></h2></div>",
                    },
                  ],
                },
                {
                  fieldGroupClassName: "row",
                  fieldGroup: [
                    {
                      key: "ownerName",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Name",
                        required: false,
                        type: "text",
                      },
                      validators: {
                        validation: ["normal-text"],
                      },
                    },
                    {
                      key: "ownerPhone",
                      type: "international-phone",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Phone",
                        required: false,
                        editing: false,
                      },
                      expressionProperties: {
                        "templateOptions.editing": () => {
                          return this.isEditMode;
                        },
                      }
                    },
                    {
                      key: "ownerEmail",
                      type: "input",
                      className: "col-md-6",
                      templateOptions: {
                        label: "Email",
                        required: false,
                        type: "email",
                      },
                      validators: {
                        validation: ["email"],
                      },
                    },
                  ],
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "productionInformation",
          fieldGroupClassName: "row",
          templateOptions: { title: "Production Information" },
          fieldGroup: [
            {
              key: "productDetailData",
              type: "gmp-product-detail",
              className: "col-md-12",
              templateOptions: {
                isDisabled: false,
                editing: false
              },
              expressionProperties: {
                "templateOptions.editing": () => {
                  return this.isEditMode;
                },
              }
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "paymentInformation",
          templateOptions: { title: "Payment Information" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                {
                  type: 'lookup',
                  key: 'inspectionFee',
                  className: 'col-md-6',
                  templateOptions: {
                    label: "Payment Category",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => res,
                    list: {
                      method: "get",
                      url: (term) => `${environment.baseUrl}/InspectionFee`,
                      responseFn: (res : Array<InspectionFee>) => {
                        return res.filter(m => m.isSra == false && m.hasMultipleFacility == false && m.code != "MTTP" && m.code != "MOF"
                          ).map(obj => ({ ...obj, name: obj.type }));
                      },
                    },
                  }
                },
                {
                  fieldGroupClassName: "col-md-12",
                  fieldGroup: [
                    {
                      template:
                        "<br><div><h2><strong>Control for good manufacturing practice (if the manufacturing companies having products in different town within one site in a country.)</strong></h2></div>",
                    },
                  ],
                },
                {
                  className: "col-md-7",
                  type: 'checkbox',
                  key: 'WHRF',
                  templateOptions: {
                      label: 'Warehouse for raw materials and finished products',
                  },
                },
                {
                  className: "col-md-7",
                  type: 'checkbox',
                  key: 'PFPQ',
                  templateOptions: {
                      label: 'For packaging of finished products, quality control and distribution license',
                  },
                },
                {
                  className: "col-md-7",
                  type: 'checkbox',
                  key: 'QCDL',
                  templateOptions: {
                      label: 'Quality control and distribution license',
                  },
                },
                {
                  key: "siteAddress",
                  type: "input",
                  className: "col-md-7",
                  templateOptions: {
                    label: "Site Address",
                    placeholder: 'Site Address',
                    required: true
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    let WHRF = field.form.get("WHRF").value;
                    let PFPQ = field.form.get("PFPQ").value;
                    let QCDL = field.form.get("QCDL").value;
                    if (WHRF != null && PFPQ != null && QCDL != null) {
                      if (WHRF == true || PFPQ == true || QCDL == true) {
                        return false;
                      }
                      return true;
                    }

                    return true;

                  },
                },
                {
                  type: "input",
                  className: "col-md-7",
                  templateOptions: {
                    label: 'Total Fee',
                    placeholder: '0',
                    dependsOnField: "productionInformation.productDetailData",
                    disabled: true
                  },
                  expressionProperties: {
                    'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                      let appliedFees = [];
                      let totalFee = 0;
                      // for normal abroad => payment category + multiple facility + >2 production line fees 
                      if(model.inspectionFee){
                         appliedFees.push(this.inspectionFees.find(f => f.id == model.inspectionFee.id));                        
                      }
                      
                      let checkBoxKeys = (<any>Object).entries(model).map(m => m[0]).filter(key => ['WHRF', 'PFPQ', 'QCDL'].indexOf(key) != -1)
                      for (const key of checkBoxKeys) {
                        if(model[key] == true){
                          appliedFees.push(this.inspectionFees.find(f => f.code == key));
                        }
                      }

                      let nonProdLineFee = appliedFees.map(f => f.amount).reduce((prev, current) => prev + current, 0);    

                      let prodDetails = field.form.parent?.value?.productionInformation?.productDetailData?.productDetails;
                      let extraProdLines = Math.max(0, this.inspectionService.countProductionLinesForFee(prodDetails) - 2);
                      if(extraProdLines > 0) {
                        const mttp = this.inspectionFees.find(f => f.code == 'MTTP');
                        appliedFees.push(mttp);
                        totalFee += mttp.amount * extraProdLines;
                      }

                      // multiple offsite facility payment
                      if(prodDetails && prodDetails.length > 0) {
                        const { uniqueOffsiteFacilitiesByNameAndAddressCount } = this.inspectionService.getOffsiteFacilitiesInfo(prodDetails)  

                        if(uniqueOffsiteFacilitiesByNameAndAddressCount > 0) {
                          appliedFees.push(this.inspectionFees.find(f => f.code == "MOF"));
                          totalFee += (uniqueOffsiteFacilitiesByNameAndAddressCount * this.inspectionFees.find(f => f.code == "MOF").amount);
                        }                
                      }

                      totalFee += nonProdLineFee;
                      return totalFee + " (in USD)"; 
                    },
                  },
                }, 
                {
                  fieldGroupClassName: "col-md-7",
                  fieldGroup: [
                    {
                      template: "",
                     
                      expressionProperties: {
                        'template': () => {
                          let multipleProdLineFee = this.inspectionFees.find(f => f.code == 'MTTP');
                          let template = "";
                          if(multipleProdLineFee){
                            template += `<span><span class='text-danger'>*</span>when more than two production lines are selected, 
                              each production line added costs ${multipleProdLineFee.amount} (in USD) </span>`
                          }
                          let multipleOffsiteFacilityFee = this.inspectionFees.find(f => f.code == 'MOF');
                          if(multipleOffsiteFacilityFee) {
                            template += `<br/> <span><span class='text-danger'>*</span>when offsite facilities are added, 
                              each offsite facility added costs ${multipleOffsiteFacilityFee.amount} (in USD) </span>`
                          }
                          return template;
                        },
                      },
                    },
                  ],
                },            
              ]
            }
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "fileAttachment",
          templateOptions: {
            title: "File Attachment",
            icon: "fa fa-info-circle",
          },
          fieldGroup: [
            {
              key: "documents",
              type: "upload-list",

              templateOptions: {
                label: "Applicant Name",
                required: true,
                items: [],
                dependsOnField: "applicantInformation.applicantType",
                dataSourceFn: (submoduleCode) => {
                  return {
                    url: `/DocumentRef/GMP/${submoduleCode}`,
                  };
                },
                extraData: {
                  urlParameter: "",
                  originalFileName: "-",
                  editing: false,
                  categoryTypeID: "",
                  AgencyTypeID: "",
                  ApplicantTypeID: "",
                },
                responseFn: (res) => res,
              },
              expressionProperties: {
                "templateOptions.extraData.urlParameter": (
                  model,
                  formState,
                  field
                ) => {
                  return this.currentInspectionType;
                },
                "templateOptions.extraData.editing": () => {
                  return this.isEditMode;
                },
                "templateOptions.extraData.categoryTypeID": () => {
                  return this.categoryId;
                },
                "templateOptions.extraData.AgencyTypeID": () => {
                  return this.agencyId;
                },
                "templateOptions.extraData.ApplicantTypeID": () => {
                  return this.applicantTypeId;
                },
              },
            },
          ],
        },
      ],
    },
  ];
}
